// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"606":"2b114024","703":"7858b579","787":"befd8d10"}[chunkId] + ".chunk.js";
};